import React from 'react';
import Router from './router';
import {Provider} from 'react-redux';
import {store} from './store'

import SKInitializer from './components/SKInitializer';

// import './static/css/bootstrap.css';
// import './static/css/bootstrap-multiselect.css'
// import './static/css/styles.css';
// import './static/css/adaptive.css';
// import './static/css/custom.css';
// import './static/css/circle.css';
// import './static/css/fonts.css';
// import './static/css/swiper.css';
// import './static/css/react-select.css';
// import './static/css/app.css';
// import './static/css/content.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import './static/scss/index.scss';

class App extends React.Component {
  render = () => (
    <Provider store={store}>
      <SKInitializer />
      <Router />
    </Provider>
  )
}

export default App;
